//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { closeDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useHighSalaryWarningDialog() {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const onClose = () => {
    dispatch(closeDialog());
  };

  const getHighSalaryWarningDialog = (): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.HighSalaryWarningHeader),
      dialogType: DialogEnums.DialogType.Message,
      titleIcon: IconDefinitionConstants.WWarningCanvas,
      children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.HighSalaryWarningDescription),
      maxWidth: "sm",
      hideCancelButton: true,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.Close),
          onClick: async () => onClose(),
        },
      ],
    };
  };

  return getHighSalaryWarningDialog;
}

export default useHighSalaryWarningDialog;
